// src/components/Layout.jsx
import React from 'react';
import Sidebar from '../components/Admin3Sidebar';

const Layout = ({ children }) => {
  return (
    <div>
      <Sidebar />
      <div>
        {children}
      </div>
    </div>
  );
};

export default Layout;
